<template>
  <div>
    <div :class="{'navigation-trigger': true, 'd-xl-none': true, toggled: sidebarVisible}" @click="toggleSidebar()">
      <div class="navigation-trigger__inner">
        <i class="navigation-trigger__line"></i>
        <i class="navigation-trigger__line"></i>
        <i class="navigation-trigger__line"></i>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapState, mapActions, mapGetters} from 'vuex';

  export default {
    components: {},
    data() {
      return {}
    },
    computed: {
      ...mapState([
        'sidebarVisible'
      ])
    },
    methods: {
      ...mapActions([
        'toggleSidebar'
      ]),
    },
    beforeCreated() {
    },
    created() {
    },
    mounted() {
    }
  }
</script>
<style lang="scss">
  // Import Bootstrap and App variables and mixins
  @import "../../assets/scss/inner-imports";

  .navigation-trigger {
    float: left;
    padding: 2rem 2rem 2rem 2.4rem;
    margin-left: -2rem;

    &:hover {
      cursor: pointer;
    }

    &.toggled {
      .navigation-trigger__inner {
        transform: rotate(180deg);

        &:before {
          transform: scale(1);
        }
      }

      .navigation-trigger__line {
        &:first-child {
          width: 12px;
          transform: translateX(8px) translateY(1px) rotate(45deg);
        }

        &:last-child {
          width: 11px;
          transform: translateX(8px) translateY(-1px) rotate(-45deg);
        }
      }
    }
  }

  .navigation-trigger__inner,
  .navigation-trigger__line {
    width: 18px;
    @include transition(all 300ms);
  }

  .navigation-trigger__inner {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      width: 40px;
      height: 40px;
      left: -11px;
      top: -14px;
      background-color: rgba($white, 0.25);
      border-radius: 50%;
      @include transition(all 300ms);
      transform: scale(0);
    }
  }

  .navigation-trigger__line {
    height: 2px;
    background-color: $white;
    display: block;
    position: relative;

    &:not(:last-child) {
      margin-bottom: 3px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/navigation-trigger.vue